import { Children } from "react";
const getSlideCount = children => Children.count(children);
export default getSlideCount;